// services/useAdminService.ts

import { useAuthenticatedFetch } from './apiService';
import { snakeToCamelObject } from '../utils/snakeToCamel';

export interface ScenarioSummary {
  id: number | null;
  title: string;
  description?: string | null;
  duration?: number | null;
  createdAt?: string | null;
  active?: boolean | null;
  published?: boolean | null;
  name?: string;
  prompt?: string;
  createdBy?: string | null;
}

export interface ScorePromptSummary {
  id: number | null;
  name: string;
  prompt: string;
  createdBy?: string | null;
}

export interface ScenarioDetailsResponse {
  scenario: ScenarioSummary;
  scorePrompt?: ScorePromptSummary | null;
}

export const useAdminService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  return {
    fetchAllScenarioDetails: async (): Promise<ScenarioSummary[]> => {
      const res = await authenticatedFetch('/scenario/details/all');
      if (!res.ok) throw new Error('Failed to fetch scenario details');
      const data: ScenarioDetailsResponse[] = snakeToCamelObject(await res.json());
      // Merge scorePrompt fields (except id) into scenario
      return data.map(({ scenario, scorePrompt }) => {
        if (scorePrompt) {
          const { id, ...scorePromptWithoutId } = scorePrompt;
          return {
            ...scenario,
            ...scorePromptWithoutId,
          };
        }
        return scenario;
      });
    },
  };
};